// Prompt builder for the QM Handbuch wizard. Mirrors the legacy
// `web/public/app.js` submit handler so the agent receives the same
// instructions and can reuse existing system prompts unchanged.

import type { QmInput } from "./api";

interface BuildPromptOptions {
  slug: string;
  websiteUrl: string;
  hasUploadedDocs: boolean;
  payload: QmInput;
}

export function buildQmPrompt({ slug, websiteUrl, hasUploadedDocs, payload }: BuildPromptOptions): string {
  const runDirHint = `output/legacy_${slug}`;
  const docsHint = hasUploadedDocs
    ? `\nHochgeladene Dokumente (Lebensläufe, Firmenprofil, Zertifikate etc.) liegen in: ${runDirHint}/data/uploaded_documents.md – lies diese Datei als zusätzliche Informationsquelle.`
    : "";
  const websiteHint = websiteUrl
    ? `\nWebsite: ${websiteUrl} – bitte scrape nach ${runDirHint}/data/website.md und nutze die Inhalte als zusätzliche Informationsquelle.`
    : "";

  return `Erstelle ein QM-Handbuch für folgendes Unternehmen.

Run-Verzeichnis: ${runDirHint}
Die Formulardaten liegen in: ${runDirHint}/data/qm_input.json${docsHint}${websiteHint}

Unternehmensname: ${payload.stammdaten.unternehmensname}
Sitz: ${payload.stammdaten.sitz_adresse}
Beratungsfelder: ${payload.beratungsfelder.kern_beratungsfelder.join(", ") || "(siehe qm_input.json)"}
Zielgruppen: ${payload.zielgruppen.hauptzielgruppen.join(", ") || "(siehe qm_input.json)"}

Führe bitte die Pipeline gemäß System-Prompt durch und schreibe das fertige QM-Handbuch nach: ${runDirHint}/qm_handbuch.md`;
}

const RECHTSFORM_RE = /\b(GmbH|UG|AG|GbR|e\.K\.|KG|OHG|eG|SE)\b/i;
export function detectRechtsform(name: string): string {
  return name.match(RECHTSFORM_RE)?.[0] ?? "";
}
